import React, { useEffect } from 'react'
import Banner from './Banner/Banner'
import Advantage from './Advantage/Advantage'
import Howitworks from './Howitworks/Howitworks'
import Faqs from './Faqs/Faqs'
import Articles from './Articles/Articles'
// import { IS_BLOGS_ACTIVE } from '../../utils/Enviroment'
import SEO from '../SEO'
import Navbar from './Navbar/Navbar'
import Storm from './Storm/Storm'
import Footer from './footer/Footer'
import { useTheme } from '../../contexts/ThemeProvider'
import { Helmet } from 'react-helmet'

const Homepage = ({ show6, setShow6 }) => {
    const { theme, toggle } = useTheme();

    useEffect(() => {
        if (theme !== "dark") {
            toggle();
        }
    }, []);
    useEffect(() => {
        document.body.classList.add("home-page-body");
        return () => {
            document.body.classList.remove("home-page-body");
        };
    }, []);
    const faqSchema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
            {
                "@type": "Question",
                name: "What exactly is the Rain Protocol?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Rain is a decentralized infrastructure layer specifically designed for building prediction markets. Unlike end-user apps, Rain provides the SDKs, APIs, and smart contracts needed for anyone to launch their own markets."
                }
            },
            {
                "@type": "Question",
                name: "How do I start building on Rain?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "It’s simple. You can explore our documentation to integrate our SDK/API or register through the Builder Portal."
                }
            },
            {
                "@type": "Question",
                name: "Who can apply for the $5M Grants Program?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "We welcome developers, creators, and teams building unique applications on top of Rain. If your project brings value to the ecosystem, you may be considered for a grant."
                }
            },
            {
                "@type": "Question",
                name: "How does the revenue-sharing model work for builders?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Rain is built to reward its ecosystem. Builders earn a certain percentage of the trading volume generated by their specific markets or applications."
                }
            },
            {
                "@type": "Question",
                name: "What makes Rain different from other prediction markets?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Rain is a permissionless protocol. It allows users to create both private and public markets, integrates AI-powered automated resolution, and lets communities use their native token for trading."
                }
            }
        ]
    };
    return (
        <>
            <Helmet>
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        name: "Rain",
                        url: "https://www.rain.one/",
                        logo: "https://www.rain.one/assets/logo.svg",
                        alternateName: "Rain Protocol",
                        description:
                            "Rain Protocol is a decentralized infrastructure for permissionless prediction markets. Create, trade, and resolve custom markets on any event with our AI-powered oracle and cross-chain capabilities.",
                        knowsAbout: [
                            "Decentralized Finance (DeFi)",
                            "Prediction Markets",
                            "AI Oracles",
                            "Blockchain Technology",
                            "Smart Contracts",
                            "Web3 Infrastructure",
                            "On-chain Governance",
                        ],
                        brand: {
                            "@type": "Brand",
                            name: "Rain Protocol",
                        },
                        sameAs: [
                            "https://x.com/Rain__Protocol",
                            "https://t.me/+fAv7-KCqpis0NDI0",
                            "https://t.me/+BzviyctWgixiNTE0",
                            "https://discord.com/invite/rainprotocol",
                            "https://www.linkedin.com/company/rainprotocol",
                            "https://www.youtube.com/@Rain_Protocol",
                            "https://coinmarketcap.com/community/?topic=rain",
                            "https://zealy.io/cw/rainzealy/questboard",
                            "https://linktr.ee/rain_protocol",
                        ],
                    })}
                </script>

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "WebSite",
                        name: "Rain",
                        alternateName: "Rain Protocol",
                        url: "https://www.rain.one/",
                    })}
                </script>

                <script type="application/ld+json">
                    {JSON.stringify(faqSchema)}
                </script>


            </Helmet>
            <SEO
                title="Rain | Decentralized Predictions Market Protocol"
                description="The decentralized prediction markets protocol where anyone can create and trade markets on any topic."
            />
            <Navbar />
            <div className="container-set-homepage">
                <Banner show6={show6} setShow6={setShow6} />
                <Advantage />
                <Howitworks />
                <Faqs />
                {/* {IS_BLOGS_ACTIVE &&  <Articles />} */}
                <Storm />
            </div>
            <Footer />
        </>
    )
}

export default Homepage
